import type { Asset, AssetBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<Asset, AssetBase>({
  tableName: "assets",
  viewName: "assets_enriched",
  searchColumns: ["name", "code", "serial_number"],
  computedColumns: ["locationName", "parentName"],
});

export class AssetService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static createMany = base.createMany;
  static update = base.update;
  static delete = base.delete;
}
